import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { rem } from "assets/js/common";
import axios from "axios";
import { loadEventAction, loadWinnerAction } from "redux/reducers/event/index";
import moment from "moment";
import { loadAlert } from "redux/reducers/top";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  fav: {
    "& button": {
      width: rem(32),
      height: rem(32),
      minWidth: "auto",
    },
    "& span": {
      fontSize: rem(15),
      fontWeight: 800,
    },
  },
}));

export default function FavoriteItem(props) {
  const classes = useStyles();
  const cookies = new Cookies();
  const token = cookies.get("X-AUTH-TOKEN");
  let { mode } = props;
  const dispatch = useDispatch();
  let [item, setItem] = useState("");

  const { schForm, event, winner, loading } = useSelector(
    (state) => state.event
  );

  const handleFav = () => {

    if (token && item.seq) {
      console.log("handleFav", item);
      axios
        .post(`/api/eh/${mode}/like`, {
          seq: item.seq,
        })
        .then((res) => {
          loadAction(res.data.data);
        });
    } else {
      dispatch(loadAlert(true));
    }


  };

  const loadAction = (data) => {
    let seq = item.seq;

    console.log("data", data);
    setItem({
      ...item,
      favCnt: data == "Y" ? item.favCnt + 1 : item.favCnt - 1,
      favYn: data,
    });
    console.log("item", item);
  };

  useEffect(() => {
    console.log("event", event);
    if (mode == "event") {
      setItem(event);
    } else if (mode == "event-winner") {
      setItem(winner);
    }
  }, [event, winner]);

  return (
    <div className={classes.fav}>
      {item.favYn == "Y" ? (
        <>
          <Button onClick={handleFav}>
            <img src={`${process.env.PUBLIC_URL}/images/icon/favorite.svg`} />
          </Button>
          <span style={{ color: "#F1270B" }}>{item.favCnt}</span>
        </>
      ) : (
        <>
          <Button onClick={handleFav}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icon/favorite-off.svg`}
            />
          </Button>
          <span style={{ color: "#CCCCCC" }}>{item.favCnt}</span>
        </>
      )}
    </div>
  );
}
